import {
  Collapse,
  Steps,
} from 'UI';
import styled from 'styled-components';
import React from 'react';

export const CollapseWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 1rem;

  & .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    cursor: default;
    padding: 0;
  }

  & .ant-collapse > .ant-collapse-item > .ant-collapse-content {
    cursor: auto;
  }
`;

export const ClickableStep = styled(Steps.Step)<React.ComponentProps<typeof Steps.Step>>`
  ${({ disabled }) => (
    !disabled
      ? `
        & {
          cursor: pointer;
        }

        & .ant-steps-item-description {
          cursor: auto;
        }
      `
      : ''
  )}
`;

export const StepCollapse = styled(Collapse)`
  width: 100%;
`;

export const StepCollapsePanel = styled(Collapse.Panel)`
  & .ant-collapse-content-box {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const MoreIconWrapper = styled.div<{
  isVisible: boolean
}>`
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  height: ${({ isVisible }) => (isVisible ? '22px' : '0')};
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
`;
